import { render } from "./DialogForms.vue?vue&type=template&id=f9573762&ts=true"
import script from "./DialogForms.vue?vue&type=script&lang=ts"
export * from "./DialogForms.vue?vue&type=script&lang=ts"

import "./DialogForms.vue?vue&type=style&index=0&id=f9573762&lang=css"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__